import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import Typography from '@/components_new/Typography.vue'
import Button from '@/components_new/Button.vue'
import { onMounted, ref, computed } from 'vue'

const defaultLineHeight = 16


export default /*@__PURE__*/_defineComponent({
  __name: 'SeoText',
  props: {
    content: {},
    minLinesToShow: { default: 5 },
    color: { default: 'white-60' }
  },
  setup(__props: any) {

const props = __props

const content = computed(() => {
    let result = props.content

    /**
     * The props.content can be an invalid html string.
     * If that happens, the result SSR can be invalid as well, leading to broken layout on the client.
     * However, if this component is mounted without hydration, it will be fine, as on the client vue passes v-html content though DOMParser which autofixes all issues.
     * So the only problem is to do the same "fix" on the server side.
     * For that I'm using cheerio parsing/serialization.
     */
    if (typeof window === 'undefined') {
        /**
         * require() happens only on server
         * "cheerio" is added to webpack "externals" to prevent bundling
         */
        const loadOptions = null
        const isDocument = false // we are parsing "fragment"
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        result = require('cheerio').load(result, loadOptions, isDocument).html()
    }

    // Process the content: remove HTML comments and add lazy loading
    return (
        result
            // Remove HTML comments
            .replace(/<!--[\s\S]*?-->/g, '')
            // Add loading="lazy" to img tag
            .replace(/(<img\s)([^>]*?)(\/?>)/gi, (match, start, attributes, end) => {
                if (attributes.includes('loading=')) {
                    return match
                }
                return `${start}loading="lazy" ${attributes}${end}`
            })
            // Add loading="lazy" to iframe tag
            .replace(/(<iframe\s)([^>]*?)(>)/gi, (match, start, attributes, end) => {
                if (attributes.includes('loading=')) {
                    return match
                }
                return `${start}loading="lazy" ${attributes}${end}`
            })
    )
})
const seoRef = ref<InstanceType<typeof Typography> | null>(null)
const seoExpanded = ref(false)
function onExpandTextClick() {
    seoExpanded.value = true
}

onMounted(() => {
    if (!seoRef.value?.$el) {
        return
    }
    const seoClientHeight = seoRef.value.$el.clientHeight
    const seoScrollHeight = seoRef.value.$el.scrollHeight
    let seoLineHeight = parseInt(window.getComputedStyle(seoRef.value.$el).lineHeight, 10)
    if (Number.isNaN(seoLineHeight)) {
        seoLineHeight = defaultLineHeight
    }
    const diff = seoScrollHeight - seoClientHeight
    if (diff / seoLineHeight > props.minLinesToShow) {
        seoExpanded.value = false
    } else {
        seoExpanded.value = true
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Typography, {
      is: "div",
      ref_key: "seoRef",
      ref: seoRef,
      type: "paragraph",
      size: "xs",
      responsive: false,
      class: _normalizeClass([_ctx.$style.seo, { [_ctx.$style.seo_expanded]: seoExpanded.value }, _ctx.$style[props.color]])
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          key: seoExpanded.value ? 'expanded' : 'collapsed',
          "data-allow-mismatch": "",
          innerHTML: content.value
        }, null, 8, _hoisted_1))
      ]),
      _: 1
    }, 8, ["class"]),
    (!seoExpanded.value)
      ? (_openBlock(), _createBlock(Button, {
          key: 0,
          class: _normalizeClass(_ctx.$style.seo_button),
          color: "carbon-400",
          interfaceTarget: "expand-description",
          onClick: onExpandTextClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$tr('seo.show_full')), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}
}

})